import styled from 'styled-components';

import MuiContainer from '@material-ui/core/Container';

export const Container = styled(MuiContainer)`
  padding: ${({ theme }) => theme.spacing(0)}px;
`;
